/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { orgSettingsState } from "./org-settings.state"; 

const orgSettings = createSlice({
    name: "orgSettings",

    initialState: orgSettingsState,

    reducers: {
        setOrgSettings (state, action) {
            const settings = action.payload;
            state.all = settings;
        },
        getOrgSettings (state) {
            return state.all;
        },
        getOrgSetting (state, action) {
            const key = action.payload;
            return state.all[key];
        }
    },
});

export const orgSettingsReducer = orgSettings.reducer;

export const {
    setOrgSettings,
    getOrgSettings,
    getOrgSetting
} = orgSettings.actions;
